/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ComponentLinkTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid } from "@mui/material";
import React from "react";
import ComponentCard from "../../../../pages/regulatory-compliance/Link/ComponentCard";

function ComponentLinkTemplate({
  leftCardHeader,
  leftPage,
  leftRowsPerPage,
  leftTotalCount,
  leftDataList,
  leftHandleSelectedComponent,
  leftSelectedComponentDetails,
  leftRenderCardActionIcons,
  leftHandlePageChange,
  leftCardID,
  leftCardStyleProp,
  rightCardHeader,
  rightPage,
  rightRowsPerPage,
  rightTotalCount,
  rightDataList,
  rightHandleSelectedComponent,
  rightSelectedComponentDetails,
  rightRenderCardActionIcons,
  rightHandlePageChange,
  rightCardID,
  rightCardStyleProp,
}) {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <ComponentCard
            headerTitle={leftCardHeader}
            dataList={leftDataList}
            handleSelectedComponent={leftHandleSelectedComponent}
            selectedComponentDetails={leftSelectedComponentDetails}
            renderCardActionIcons={leftRenderCardActionIcons}
            page={leftPage}
            rowsPerPage={leftRowsPerPage}
            handlePageChange={leftHandlePageChange}
            totalCount={leftTotalCount}
            idKey={leftCardID}
            cardStyleProp={leftCardStyleProp || ((item) => ({}))}
          />
        </Grid>

        <Grid item sm={6}>
          <ComponentCard
            headerTitle={rightCardHeader}
            dataList={rightDataList}
            handleSelectedComponent={rightHandleSelectedComponent}
            selectedComponentDetails={rightSelectedComponentDetails}
            renderCardActionIcons={rightRenderCardActionIcons}
            page={rightPage}
            rowsPerPage={rightRowsPerPage}
            handlePageChange={rightHandlePageChange}
            totalCount={rightTotalCount}
            idKey={rightCardID}
            cardStyleProp={rightCardStyleProp || ((item) => ({}))}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default ComponentLinkTemplate;
